// src/App.jsx  (Phase 2)
import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppProvider, useApp } from './context/AppContext'
import AppShell      from './components/AppShell'
import Login         from './pages/Login'
import Signup        from './pages/Signup'
import Dashboard     from './pages/Dashboard'
import Transactions  from './pages/Transactions'
import Ledger        from './pages/Ledger'
import Accounts      from './pages/Accounts'
import Reports       from './pages/Reports'
import Pricing       from './pages/Pricing'
import Legal         from './pages/Legal'
import CookieBanner  from './components/CookieBanner'

function AuthGuard({ children }) {
  const { currentUser, authLoading } = useApp()
  if (authLoading) return <Spinner />
  return currentUser ? children : <Navigate to="/login" replace />
}

function GuestGuard({ children }) {
  const { currentUser, authLoading } = useApp()
  if (authLoading) return <Spinner />
  return currentUser ? <Navigate to="/transactions" replace /> : children
}

function Spinner() {
  const { t } = useTranslation()
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <div style={{ textAlign: 'center' }}>
        <i className="ti ti-loader-2" style={{ fontSize: 32, color: 'var(--brand-400)', animation: 'spin 1s linear infinite' }} aria-hidden="true" />
        <p style={{ marginTop: 12, color: 'var(--gray-600)', fontSize: 13 }}>{t('common.loading')}</p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"  element={<GuestGuard><Login /></GuestGuard>} />
      <Route path="/signup" element={<GuestGuard><Signup /></GuestGuard>} />
      <Route path="/legal"  element={<Legal />} />
      <Route element={<AuthGuard><AppShell /></AuthGuard>}>
        <Route index element={<Dashboard />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="ledger"       element={<Ledger />} />
        <Route path="accounts"     element={<Accounts />} />
        <Route path="reports"      element={<Reports />} />
        <Route path="pricing"      element={<Pricing />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
        <CookieBanner />
      </BrowserRouter>
    </AppProvider>
  )
}
